var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.46,
    height: 109.667,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.548v84.877a7.251 7.251 0 007.243 7.242h70.978a7.251 7.251 0 007.243-7.242V7.242A7.251 7.251 0 0078.221 0H7.247A7.251 7.251 0 00.004 7.242v10.306z",
    fill: "#e0ecf4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.321 63.428a4.557 4.557 0 004.552 4.552h57.725a4.558 4.558 0 004.552-4.552V46.239a4.558 4.558 0 00-4.552-4.552H13.873a4.557 4.557 0 00-4.552 4.552zM76.145 85.09v-6.053a4.558 4.558 0 00-4.552-4.552H13.868a4.557 4.557 0 00-4.552 4.552v17.189a4.557 4.557 0 004.552 4.552h57.725a4.558 4.558 0 004.552-4.552V85.09zM13.868 35.182h57.725a4.558 4.558 0 004.552-4.552V13.441a4.557 4.557 0 00-4.552-4.552H13.868a4.556 4.556 0 00-4.552 4.552V30.63a4.557 4.557 0 004.552 4.552z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.897 27.934a1.481 1.481 0 10-1.481 1.5 1.491 1.491 0 001.481-1.5z",
    fill: "none",
    stroke: "#0c1e6c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.932
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.776 19.768h31.593a1.607 1.607 0 100-3.213H18.776a1.607 1.607 0 100 3.213z",
    fill: "#0c1e6c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.776 27.515h31.593a1.607 1.607 0 100-3.213H18.776a1.607 1.607 0 100 3.213z",
    fill: "#6d8dc1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.897 60.731a1.481 1.481 0 10-1.481 1.5 1.491 1.491 0 001.481-1.5z",
    fill: "none",
    stroke: "#0c1e6c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.932
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.776 52.566h31.593a1.607 1.607 0 100-3.213H18.776a1.607 1.607 0 100 3.213z",
    fill: "#0c1e6c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.776 60.314h31.593a1.606 1.606 0 100-3.213H18.776a1.606 1.606 0 100 3.213z",
    fill: "#6d8dc1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.897 93.53a1.481 1.481 0 10-1.481 1.5 1.491 1.491 0 001.481-1.5z",
    fill: "none",
    stroke: "#0c1e6c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.932
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.369 82.152H18.776a1.606 1.606 0 100 3.212h31.593a1.606 1.606 0 100-3.212z",
    fill: "#0c1e6c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.369 89.899H18.776a1.607 1.607 0 100 3.213h31.593a1.607 1.607 0 100-3.213z",
    fill: "#6d8dc1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.546 16.186s6.225-2.372 6.744 1.778-3.854 4.224-3.854 4.224v1.927M58.546 49.276s6.225-2.371 6.744 1.778-3.854 4.225-3.854 4.225v1.926M58.546 81.869s6.225-2.372 6.744 1.778-3.854 4.224-3.854 4.224v1.927",
    fill: "none",
    stroke: "#0c1e6c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.932
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout01);
export default __webpack_public_path__ + "static/media/about-01.39ff96f5.svg";
export { ForwardRef as ReactComponent };